const {
    OperatorsMap
} = require('./operators')

const {
    MATCH_PREDICATE_TYPE_MATCH_ALL,
    MATCH_PREDICATE_TYPE_MATCH_ANY,
    PREDICATE_PROPERTY_GROUP_TYPE_MESSAGE,
    PREDICATE_PROPERTY_GROUP_TYPE_ORDER,
    PREDICATE_PROPERTY_GROUP_TYPE_PEOPLE,
} = require('./constants')

const {
    isStoreNameFilter,
    AsyncEvery,
    AsyncSome
} = require('./utils')

const handlePredicateForTypeConversation = async (predicate, conversation) => {
    let { attributeType, attributeKey, attributeValue, attributeOperator } = predicate;

    const isSelectProp = ['list', 'dropdownSelect', 'multiSelect', 'radioSelect', 'yesOrNo'];
    const nullValueSupportedOperator = ['is_known_for_list', 'is_unknown_for_list', 'is_unknown_for_yes_or_no', 'is_known_for_yes_or_no', 'is_available', 'is_not_available'];

    if (conversation) {
        let conversationProperties = {};
        try{
            conversationProperties = JSON.parse(conversation.conversationProperties);
        } catch(e) {
            // console.log("No Conversation Props");
        }
        let value = conversation[attributeKey];

        try {
            value = JSON.parse(conversationProperties[attributeKey]).formattedValue;
        } catch (error) {
            value = conversationProperties[attributeKey];
        }

        if(!value) {
            value = conversation[attributeKey]
        }

        // Check if in case the attribute check is for channel
        if(attributeKey === 'channel') {
            value = conversation['type'];
        }

        if(isStoreNameFilter(attributeKey)){
            value = conversation['appClientId'];
            attributeType = 'list';
        }

        if (value || isSelectProp.includes(attributeType) || nullValueSupportedOperator.includes(attributeOperator)) {
            const operators = OperatorsMap[attributeType];
            if (operators) {
                const operator = operators[attributeOperator];
                if (operator) {
                    const { matcher } = operator;
                    if (matcher) {
                        const rv = matcher(value, attributeValue);
                        return rv;
                    }
                }
            }
        }
    };

    return false;
};

const handlePredicateForTypePeople = async (predicate, userProperties) => {

    const { attributeType, attributeKey, attributeValue, attributeOperator } = predicate;

    const isSelectProp = ['list', 'dropdownSelect', 'multiSelect', 'radioSelect', 'yesOrNo'];
    const nullValueSupportedOperator = ['is_known_for_list', 'is_unknown_for_list', 'is_unknown_for_yes_or_no', 'is_known_for_yes_or_no', 'is_available', 'is_not_available', 'does_not_contains', 'is_unknown', 'is_not', 'is_any_of_yes_or_no', 'is_none_of_yes_or_no', 'is_none_of'];

    if (userProperties) {
        const value = userProperties[attributeKey];
        if (value || isSelectProp.includes(attributeType) || nullValueSupportedOperator.includes(attributeOperator)) {
            const operators = OperatorsMap[attributeType];
            if (operators) {
                const operator = operators[attributeOperator];
                if (operator) {
                    const { matcher } = operator;
                    if (matcher) {
                        const rv = matcher(value, attributeValue);;
                        return rv;
                    }
                }
            }
        }
    };

    return false;
};

const getValidRule = async (rules, properties) => {
    if (!rules || !properties) return;

    const {
        userProperties,
        orderProperties = {}
    } = properties;

    const predicateMatcher = async predicate => {
        const { attributeUnder } = predicate;

        if (attributeUnder === PREDICATE_PROPERTY_GROUP_TYPE_ORDER) {
            return await handlePredicateForTypePeople(predicate, orderProperties);
        } else if (attributeUnder === PREDICATE_PROPERTY_GROUP_TYPE_PEOPLE) {
            return await handlePredicateForTypePeople(predicate, userProperties);
        } else {
            throw new Error('Group type not found');
        }
    }

    for (let index = 0; index < rules.length; index++) {
        const rule = rules[index];
        const { predicates, matchPredicate } = rule;

        if (matchPredicate === MATCH_PREDICATE_TYPE_MATCH_ALL) {
            if (await AsyncEvery(predicates, predicateMatcher)) return rule;
        } else if (matchPredicate === MATCH_PREDICATE_TYPE_MATCH_ANY) {
            if (await AsyncSome(predicates, predicateMatcher)) return rule;
        } else {
            throw new Error('Match Predicate not found');
        }
    }

    return null;
}

const getValidScenarios = async ({ rules, properties }) => {
    return await getValidRule(rules, properties);
}

module.exports.getValidScenarios = getValidScenarios;